module.exports = __webpack_public_path__ + "media/images/ic_pin-80aab8b9e719fcd526fd2bbef2c0631a.png";